import { posToDOMRect } from "@tiptap/core";
import {
  DateChecked,
  DateCheckedSmall,
  Order,
  OrderSmall,
  WixBooking,
  WixBookingSmall
} from "@wix/wix-ui-icons-common";
import { AppEmbedData_AppType } from "./../ricos-schema/legacy/wix/rich_content/v1/index.js";
import {
  Node_Type,
  quickActionsModalSections,
  RicosPluginToolbarNames
} from "./../ricos-types/index.js";
import { changeSelectionToEndOfTextBlock } from "./../wix-rich-content-common/index.js";
import { appEmbedConverter } from "./app-embed-converter.js";
import { verticalEmbedModals } from "./constants.js";
import { DEFAULTS } from "./defaults.js";
import { getAddButtons } from "./getAddButtons.js";
import { getToolbarButtons } from "./getToolbarButtons.js";
import { InsertModal } from "./modals/InsertModal.js";
import { tiptapExtensions } from "./tiptap/tiptap.js";
import { VERTICAL_EMBED_TYPE } from "./types.js";
const pluginVerticalEmbed = (config) => {
  const pluginConfig = { ...DEFAULTS.config, ...config };
  return {
    config: pluginConfig,
    type: VERTICAL_EMBED_TYPE,
    tiptapExtensions,
    pmMarkConverters: [],
    pmNodeConverters: [appEmbedConverter],
    toolbar: {
      names: [RicosPluginToolbarNames.APP_EMBED],
      getButtons: (config2, services) => getToolbarButtons(config2, services)
    },
    getAddButtons: (config2, services) => getAddButtons(config2, services),
    getQuickActions: ({ config: config2, pluginServices }) => {
      const isMobile = pluginServices?.context.isMobile;
      const toggleInsertModal = ({
        id,
        type,
        modalService,
        editor
      }) => modalService?.togglePluginPanel({
        id,
        Component: InsertModal,
        componentProps: {
          componentData: { type },
          modalId: id
        },
        positioning: {
          referenceElement: {
            getBoundingClientRect: () => posToDOMRect(
              editor.view,
              editor.view.state.selection.from,
              editor.view.state.selection.to
            )
          },
          placement: "bottom-start"
        },
        isMobile
      });
      return [
        {
          id: `${Node_Type.APP_EMBED}.product`,
          title: "QuickActionsPlugin_ActionTitle_Product",
          icon: isMobile ? Order : OrderSmall,
          section: quickActionsModalSections.EmbedWix,
          tags: [
            "item",
            "merchandise",
            "product card",
            "shop item",
            "e-commerce",
            "online store",
            "store item"
          ],
          command: ({ modalService, editor }) => {
            changeSelectionToEndOfTextBlock(editor);
            toggleInsertModal({
              id: verticalEmbedModals.insertProduct,
              type: AppEmbedData_AppType.PRODUCT,
              modalService,
              editor
            });
          }
        },
        {
          id: `${Node_Type.APP_EMBED}.event`,
          title: "QuickActionsPlugin_ActionTitle_Event",
          icon: isMobile ? DateChecked : DateCheckedSmall,
          section: quickActionsModalSections.EmbedWix,
          tags: ["calendar", "meeting", "appointment", "schedule", "date", "time"],
          command: ({ modalService, editor }) => {
            changeSelectionToEndOfTextBlock(editor);
            toggleInsertModal({
              id: verticalEmbedModals.insertEvent,
              type: AppEmbedData_AppType.EVENT,
              modalService,
              editor
            });
          }
        },
        {
          id: `${Node_Type.APP_EMBED}.service`,
          title: "QuickActionsPlugin_ActionTitle_Service",
          icon: isMobile ? WixBooking : WixBookingSmall,
          section: quickActionsModalSections.EmbedWix,
          tags: ["reservation", "appointment", "schedule", "time", "calendar", "ticket", "booking"],
          command: ({ modalService, editor }) => {
            changeSelectionToEndOfTextBlock(editor);
            toggleInsertModal({
              id: verticalEmbedModals.insertBooking,
              type: AppEmbedData_AppType.BOOKING,
              modalService,
              editor
            });
          }
        }
      ];
    }
  };
};
export {
  pluginVerticalEmbed
};
//# sourceMappingURL=editor.js.map

import { injectCss } from "./viewer-styles-inject.js";
injectCss();
